import React from 'react'
import 'antd-mobile/dist/antd-mobile.css'
import { routerMobile } from './router/routerMobile'
import AppRouter from '../../components/router/AppRouter'
import '../../common/init/git.init'

if (
    process.env.NODE_ENV === 'development' ||
    (process.env.NODE_ENV === 'production' && process.env.REACT_APP_DEBUG === '1')
) {
    // let vConsole = require('vconsole')
    // new vConsole()
}

const AppMobile: React.FC = () => {
    return <AppRouter routes={routerMobile} />
}

export default AppMobile
